import React from 'react';
import PropTypes from 'prop-types';
// material-ui
import { useTheme } from '@mui/material/styles';
import { Divider, List, Typography, Box } from '@mui/material';

// project imports
import NavItem from '../NavItem';
import NavCollapse from '../NavCollapse';
import { useSelector } from 'react-redux';
import { useChatLive } from '../../../../../contexts/ChatLiveContext';

// ==============================|| SIDEBAR MENU LIST GROUP ||============================== //

const NavGroup = ({ item }) => {
    const theme = useTheme();
    const value = useSelector((s) => s.pendingApprovals.value);
    const { unreadTotal } = useChatLive();
    const tpsCount = JSON.parse(localStorage.getItem('userData'))?.len_of_tps_messages || 0;
    const consultantCount = useSelector((s) => s.consultantCount?.value) || 0;

    // menu list collapse & items
    const items = item.children?.map((menu) => {
        switch (menu.type) {
            case 'collapse':
                return <NavCollapse key={menu.id} menu={menu} level={1} />;
            case 'item':
                if (menu.id === "consultationrequests") {
                    return (
                        <NavItem key={menu.id} item={menu} level={1} value={value} />
                    );
                }
                if (menu.id === "tpsinbox") {
                    return (
                        <NavItem key={menu.id} item={menu} level={1} value={tpsCount} />
                    );
                }
                if (menu.id === "consultationcase") {
                    return (
                        <NavItem key={menu.id} item={menu} level={1} value={consultantCount} />
                    );
                }
                if (menu.id === "peersharerequests") {
                    const pendingPeerShare =
                        JSON.parse(localStorage.getItem('userData') || '{}')
                            ?.peer_share_requests_pending_count || 0;
                    return (
                        <NavItem key={menu.id} item={menu} level={1} value={pendingPeerShare} />
                    );
                }
                if (menu.id === "orthero-chat") {
                    return (
                        <NavItem key={menu.id} item={menu} level={1} value={unreadTotal} />
                    );
                }
                if (menu.id === "profile-settings") {
                    const friendRequestCount =
                        JSON.parse(localStorage.getItem('userData') || '{}')
                            ?.friend_request_count || 0;
                    return (
                        <NavItem key={menu.id} item={menu} level={1} value={friendRequestCount} />
                    );
                }
                return <NavItem key={menu.id} item={menu} level={1} />;
            case 'search':
                return (
                    <Box key={menu.id} sx={{ px: 2, py: 1 }}>
                        {menu.title}
                    </Box>
                );
            default:
                return (
                    <Typography key={menu.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    

    return (
        <>
            <List
                subheader={
                    item.title && (
                        <Typography variant="caption" sx={{ ...theme.typography.menuCaption }} display="block" gutterBottom>
                            {item.title}
                            {item.caption && (
                                <Typography variant="caption" sx={{ ...theme.typography.subMenuCaption }} display="block" gutterBottom>
                                    {item.caption}
                                </Typography>
                            )}
                        </Typography>
                    )
                }
            >
                {items}
            </List>

            {/* group divider */}
            <Divider sx={{ mt: 0.25, mb: 1.25 }} />
        </>
    );
};

NavGroup.propTypes = {
    item: PropTypes.object
};

export default NavGroup;
